import type { FaireProductEntity } from "../../entity_types/product";

export const p_fp6c5tfe2x: FaireProductEntity = {
  token: "p_fp6c5tfe2x",
  type: "product",
  name: "ARDWARE HALTER TOP",
  brandToken: "b_22tswwgnqb",
  brandName: "Emory Park",
  imageUrl:
    "https://cdn.faire.com/fastly/2ead07ede7694e88dc31146253c3f9add3cf2677ca4a3cb4bf009f829445f6b9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bed2e035c7c221c61de2aa359a28a12d0b9ceb26982deb82e60ed36c4cf551ca.jpeg",
    "https://cdn.faire.com/fastly/98e588ed96589ba8b0f476523363e6daf234ee82015a149edbccc67cd91b9257.jpeg",
    "https://cdn.faire.com/fastly/67229a035fe21b4dc5c380557642129812a6da758dd97ed534f0eab6a5758d5c.jpeg",
    "https://cdn.faire.com/fastly/4621ee62d35d2c29b49aacf487e3d4a32cab69ebc137aa8cd99e4cccf15b5ad6.jpeg",
    "https://cdn.faire.com/fastly/4a33d1862afd9aa66242001db69ad5924f7f394fbd49a3d98a472fde27fae27e.jpeg",
    "https://cdn.faire.com/fastly/3d7e22ad0790124036c61422bd89925aa05e0fabbfe67e10ac7f9eedf883df19.jpeg",
    "https://cdn.faire.com/fastly/27388267481653e249245350f41916c6d39a268e117e299f2c6aeec6d6ef3a49.jpeg",
    "https://cdn.faire.com/fastly/5d5314ed35af54b00c4f4218eb789075accdb21d55d8a24ee569298aba689a4b.jpeg",
    "https://cdn.faire.com/fastly/a74fe5ada6cb41a3aad752ce05d7c1dba8101a5a5052684896e3533c6e234c2b.jpeg",
    "https://cdn.faire.com/fastly/3bcdb043f40dc41f269b5bccc9f3171df9dd98da1354844cf44d68fe1b572a8d.jpeg",
    "https://cdn.faire.com/fastly/2cde8d55276336aed4d12609e49d11f8f901348933af154e615877b760894d21.jpeg",
    "https://cdn.faire.com/fastly/ed5c1a687b64b88a41e5554f3c02374aa43d54944d2ff07198ca45bfd1930e6d.jpeg",
    "https://cdn.faire.com/fastly/88b19745f70f8502a75acee778a3e12197cf3c254651e850fd8f49d1158f7ad7.jpeg",
  ],
  priceDollars: 162.12,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 324.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:54.706Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
